import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 40);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const navItems = [
    { path: '/', label: 'HOME' },
    { path: '/about', label: 'ABOUT US' },
    { path: '/services', label: 'SERVICES' },
    { path: '/gallery', label: 'GALLERY' },
    { path: '/contact', label: 'CONTACT' },
  ];

  const isHome = location.pathname === '/';
  const isActive = (path) => path === '/' ? isHome : location.pathname.startsWith(path);

  return (
    <nav className={`site-nav fixed top-0 left-0 right-0 z-50 ${isScrolled || !isHome ? 'site-nav-scrolled' : 'site-nav-hero'}`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-[76px]">
          <Link to="/" className="logo-lockup flex flex-col items-center" aria-label="Inarch Design Studio home">
            <span className="font-logo text-2xl font-bold text-white leading-none">
              <span className="text-[#B87333]">I</span>DS
            </span>
            <span className="font-logo text-[10px] tracking-wider text-white/90" style={{ marginTop: '2px' }}>
              <span className="text-[#B87333]">Inarch</span> Design Studio
            </span>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link key={item.path} to={item.path} className={`nav-link relative text-sm tracking-wider ${isActive(item.path) ? 'nav-link-active' : ''}`}>
                {item.label}
              </Link>
            ))}
          </div>

          <a href="https://wa.me/918591613610" target="_blank" rel="noopener noreferrer" className="hidden md:inline-flex btn-copper nav-cta px-6 py-2.5 text-sm tracking-wider">
            GET IN TOUCH
          </a>

          <button className="md:hidden text-white p-2 -mr-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'} aria-expanded={isMobileMenuOpen}>
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="mobile-menu md:hidden pb-5 border-t border-white/10">
            {navItems.map((item) => (
              <Link key={item.path} to={item.path} onClick={() => setIsMobileMenuOpen(false)} className={`block py-3 text-sm tracking-wider ${isActive(item.path) ? 'text-[#D4956A]' : 'text-white'}`}>
                {item.label}
              </Link>
            ))}
            <a href="https://wa.me/918591613610" target="_blank" rel="noopener noreferrer" className="block mt-3 btn-copper px-6 py-2.5 text-sm tracking-wider text-center">
              GET IN TOUCH
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
